<template>
  <section class="partner-bank">
    <button v-if="!loaded" type="button" :disabled="loading" @click="load">{{ loading ? 'Consultando…' : 'Consultar cuenta bancaria para transferir' }}</button>
    <p v-if="error" role="alert">{{ error }}</p>
    <template v-if="loaded && bank"><h3>Cuenta bancaria declarada</h3><dl><div><dt>Titular</dt><dd>{{ bank.holder }}</dd></div><div><dt>RUT</dt><dd>{{ bank.rut }}</dd></div><div><dt>Banco</dt><dd>{{ bank.bank_name }}</dd></div><div><dt>Tipo</dt><dd>{{ bank.account_type_name }}</dd></div><div><dt>Número</dt><dd>{{ bank.account_number }}</dd></div></dl><p>Verifica los datos antes de transferir. Esta consulta no realiza ningún pago.</p><button type="button" @click="bank = null; loaded = false">Ocultar datos</button></template>
    <p v-else-if="loaded">Este partner no tiene una cuenta registrada mediante una postulación aprobada.</p>
  </section>
</template>
<script>
import axios from 'axios'
export default {
  name: 'LeadPartnerBankAccount',
  props: { partnerId: { type: Number, required: true } },
  data () { return { bank: null, loaded: false, loading: false, error: '' } },
  watch: { partnerId () { this.bank = null; this.loaded = false; this.error = '' } },
  methods: {
    async load () {
      const requestedPartnerId = this.partnerId
      this.loading = true; this.error = ''
      try { const { data } = await axios.get(window.hostname + `api/superadmin/lead_partners/${requestedPartnerId}/bank-account`); if (this.partnerId === requestedPartnerId) { this.bank = data.bank_account; this.loaded = true } }
      catch (error) { this.error = 'No pudimos consultar la cuenta bancaria. Intenta nuevamente.' }
      finally { this.loading = false }
    }
  }
}
</script>
<style scoped>
.partner-bank { margin-top: 20px; padding: 20px; border: 1px solid #d7e3ed; border-radius: 10px; background: #f4f8fb; }
.partner-bank h3 { font-size: 17px; font-weight: 700; }
.partner-bank button { padding: 8px 13px; border: 1px solid #bbd0df; border-radius: 6px; background: white; color: #244e6b; font-size: 13px; cursor: pointer; }
.partner-bank p { margin: 12px 0 0; color: #657b8d; font-size: 13px; }
.partner-bank dl { display: flex; flex-wrap: wrap; gap: 15px 35px; margin: 20px 0; }
.partner-bank dt { color: #61798b; font-size: 12px; font-weight: 400; }
.partner-bank dd { margin: 4px 0 0; font-size: 14px; overflow-wrap: anywhere; }
</style>
